<template>
  <div class="upgrade pricing-modal">
    <div v-if="false && !userType" class="container is-narrow is-fluid">
      <div class="notification is-dark is-darkened">
        <p>Are you a teacher? See our new pricing plans exclusively for schools and educational institutions</p>
        <div class="button is-dark is-darkened">Go to Educational Pricing &rarr;</div>
      </div>
    </div>
    <div class="container is-narrow is-fluid">
      <!-- <h3 class="title is-1 main-title has-text-centered m-t-20">Upgrade your engagement</h3> -->

      <section class="section pricing" style="padding-top: 0px;">
        <div class="container is-narrow is-fluid">
          <div class="has-text-centered">
            <template v-if="isEdu">
              <h1 class="title is-2 has-text-white-ter">{{ firstLogin ? 'New — ' : '' }}Special Plans for Educators ✨</h1>
              <p v-if="isEdu && false" class="subtitle is-4 has-text-white-ter">Motivate students with engaging and interactive lessons</p>
            </template>
            <template v-else>
              <h1 class="title is-2 has-text-white-ter">Upgrade your meetings, presentations, and training ✨</h1>
              <!-- <p class="subtitle is-4 has-text-white-ter">The easiest interactive meetings, presentations, and trainings</p> -->
            </template>

            <div :class="'is-' + period" class="top-switch">
              <!-- <div class="one-time-wrap">
                <div @click="period = 'oneTime'" :class="{'plan-active': period === 'oneTime'}" class="button is-rounded is-content one-time">One-time</div>
              </div> -->

              <div :class="['is-' + annualSwitch, 'is-' + period]" class="annual-switch">
                <div class="button is-rounded is-primary bg-highlight" />
                <div class="buttons has-addons">
                  <div @click="setPeriod('oneTime')" :class="{'plan-active': period === 'monthly' || period === 'oneTime'}" class="button is-rounded is-content">Monthly</div>
                  <div @click="setPeriod('yearly')" :class="{'plan-active': period === 'yearly'}" class="button is-rounded is-content">Yearly</div>
                  <p>&larr; Pay yearly to save {{ isEdu ? '70' : '50' }}%!</p>
                </div>
              </div>
            </div>
          </div>
          <div class="pricing-table is-comparative">
            <div class="pricing-plan is-active is-middle">
              <div class="plan-promo has-text-centered m-t-20">
                <!-- <div v-if="isAnnual" class="tag is-rounded is-secondary"><b>50%</b> &nbsp; Yearly Discount!</div> -->
                <!-- <div v-else>&nbsp;</div> -->
              </div>
              <div class="plan-header">{{ title.starter }}</div>
              <div class="plan-description">{{ description.starter }}</div>

              <div class="plan-price">
                <span class="plan-price-amount"><span class="plan-price-currency">$</span>{{ prices['starter'].perMonth }}<span v-if="period !== 'oneTime'" class="plan-price-currency">/mo</span></span>
                <div class="plan-subtitle">{{ priceSubtitle.starter }}</div>
              </div>

              <ClientOnly>
                <div class="plan-cta">
                  <a v-if="!loggedIn" :href="'/register?plan=starter&period=' + period" @click="trackEvent('Start Register Pricing')" target="_parent" class="button is-fullwidth">Get Started</a>
                  <button v-if="loggedIn && !isSubscriber" @click="startCheckout($event, 'starter')" class="button is-medium is-fullwidth is-primary is-cta">
                    {{ cta.starter }}
                    <!-- <span v-if="period === 'oneTime'" class="is-small">(one month)</span> -->
                  </button>

                  <template v-if="loggedIn && isSubscriber">
                    <div class="button is-medium is-fullwidth is-primary is-disabled" disabled>You're subscribed 🎉</div>
                    <p class="plan-description">contact us to change plans</p>
                  </template>

                  <b-switch v-if="period !== 'yearly'" v-model="autoRenew" size="is-default">
                    Automatically renew
                    <b-tooltip class="tooltip" position="is-right" type="is-dark" multilined>
                      <span class="icon">
                        <i class="fas fa-question-circle" />
                      </span>
                      <template v-slot:content>
                        <p style="text-align: left">
                          Turn this setting on to subscribe to monthly recurring billing and get uninterrupted premium access.
                          <br><br>
                          Leave this setting off to be billed for one month only. Your account will automatically downgrade to a free account after 30 days.
                        </p>
                      </template>
                    </b-tooltip>
                  </b-switch>
                </div>
              </ClientOnly>

              <div class="plan-items">
                <div><span class="emoji">🙋‍♀️</span> <b>Host up to 50 people</b></div>
                <div><span class="emoji">🎬</span> Unlimited slides &amp; events</div>
                <div><span class="emoji">💬</span> All interaction types</div>
                <div><span class="emoji">🎨</span> Custom fonts &amp; design</div>
                <div><span class="emoji">📴</span> Custom event codes</div>
              </div>
            </div>

            <div class="pricing-plan is-active is-last">
              <div class="plan-promo has-text-centered m-t-20">
                <!-- <div v-if="isAnnual" class="tag is-rounded is-secondary"><b>50%</b> &nbsp; Yearly Discount!</div> -->
                <!-- <div>&nbsp;</div> -->
              </div>
              <div class="plan-header">{{ title.pro }}</div>
              <div class="plan-description">{{ description.pro }}</div>

              <div class="plan-price">
                <span class="plan-price-amount"><span class="plan-price-currency">$</span>{{ prices[`pro${proPlayerLimit}`].perMonth }}<span v-if="period !== 'oneTime'" class="plan-price-currency">/mo</span></span>
                <div class="plan-subtitle">{{ priceSubtitle.pro }}</div>
              </div>

              <div class="limit-toggle">
                <div class="b-numberinput field is-grouped">
                  <p class="control minus">
                    <button @click="decreasePlayerLimit()" :disabled="decreaseLimitDisabled" type="button" class="button is-primary">
                      <span class="icon"><i class="fas fa-minus" /></span>
                    </button>
                  </p>
                  <div class="control is-clearfix" style="user-select: none">
                    <button class="input">{{ proPlayerLimit }} people</button>
                  </div>
                  <p class="control plus">
                    <button @click="increasePlayerLimit()" :disabled="increaseLimitDisabled" type="button" class="button is-primary">
                      <span class="icon"><i class="fas fa-plus" /></span>
                    </button>
                  </p>
                </div>
              </div>

              <ClientOnly>
                <div class="plan-cta">
                  <a v-if="!loggedIn" :href="'/register?plan=pro&period=' + period" @click="trackEvent('Start Register Pricing')" target="_parent" class="button is-fullwidth">Get Started</a>
                  <button v-if="loggedIn && !isSubscriber" @click="startCheckout($event, `pro${proPlayerLimit}`)" class="button is-medium is-fullwidth is-primary is-cta">
                    {{ cta.pro }}
                    <!-- <span v-if="period === 'oneTime'" class="is-small">(one month)</span> -->
                  </button>

                  <template v-if="loggedIn && isSubscriber">
                    <div class="button is-medium is-fullwidth is-primary is-disabled" disabled>You're subscribed 🎉</div>
                    <p class="plan-description">contact us to change plans</p>
                  </template>

                  <b-switch v-if="period !== 'yearly'" v-model="autoRenew" size="is-default">
                    Automatically renew
                    <b-tooltip class="tooltip" position="is-right" type="is-dark" multilined>
                      <span class="icon">
                        <i class="fas fa-question-circle" />
                      </span>
                      <template v-slot:content>
                        <p style="text-align: left">
                          Turn this setting on to subscribe to monthly recurring billing and get uninterrupted premium access.
                          <br><br>
                          Leave this setting off to be billed for one month only. Your account will automatically downgrade to a free account after 30 days.
                        </p>
                      </template>
                    </b-tooltip>
                  </b-switch>
                </div>
              </ClientOnly>

              <div class="plan-items m-b-20">
                <div><span class="emoji">🙋‍♀️</span> <b>Host up to {{ proPlayerLimit }} people</b></div>
                <div><span class="emoji">🎨</span> <b>Add your own branding</b></div>
                <div><span class="emoji">📦</span> Remove SlidesWith logo</div>
                <div>
                  <span class="emoji">
                    <img src="/logos/powerpoint.svg" style="height: 1.2em; width: 1.2em;">
                  </span> Import slides from PowerPoint
                </div>
                <div><span class="emoji">💾</span> Save &amp; export event data</div>
                <div><span class="emoji">➕</span>Everything from Starter</div>
                <!-- <div><span class="emoji">📴</span>Moderator tools (soon)</div> -->
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="level has-text-centered">
      <div class="level-item">
        <div @click="closeUpgradeModal()" class="button is-darkened is-dark is-medium">{{ firstLogin ? 'Let me try it first' : 'Not right now' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import PricingControls from '~/components/mixins/PricingControls.vue'
// import UserTypeForm from '~/components/modals/UserTypeForm.vue'

export default {
  name: 'UpgradeAccount',
  components: {
  },
  mixins: [PricingControls],
  // eslint-disable-next-line vue/prop-name-casing
  props: ['firstLogin', 'from_location', 'button_text'],
  computed: {
  },
  mounted () {
    const posthogProps = { from_location: this.from_location, button_text: this.button_text }
    this.posthogCapture('upgrade:modal_open', posthogProps)
  },
  methods: {
    closeUpgradeModal () {
      this.posthogCapture('upgrade:modal_cancel')
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.modal.upgrade-modal.is-full-screen .modal-content {
  background-color: #8268a1;

  .main-title.title {
    color: white;
  }
}

.upgrade-modal {
  .modal-close.is-large {
    background-color: rgba(0,0,0,.2);
    transform: scale(1.25) translateZ(0);

    &::before, &::after {
      background-color: rgba(255,255,255,.5);
    }

    &:hover {
      background-color: rgba(0,0,0,.4);

      &::before, &::after {
        background-color: rgba(255,255,255,.7);
      }
    }
  }
}
.pricing-modal {
  .notification.is-darkened {
    display: flex;
    justify-content: space-between;
  }
}
</style>

<style lang="scss" scoped>

.pricing-plan.is-free {
  display: none;
}

.pricing {

  .top-switch {
    margin: 2em auto -0.75em
  }
  .limit-toggle {
    max-width: 300px;
    margin: 0em auto 1em;
    text-align: center;

    .button {
      justify-content: center;
    }
  }

  .pricing-table {
    justify-content: center;
    .pricing-plan, .pricing-plan.is-active {
      width: 34%;
      max-width: 450px;
      box-shadow: 1px 10px 34px -14px rgba(31, 51, 73, .15);
      margin-right: 2.5%;
      border-radius: 14px;
      border: none ;
      padding-bottom: 1em;

      &.is-last {
        // border-top-left-radius: 0px;
        // border-bottom-left-radius: 0px;
        margin-left: -1px;
        margin-right: 0;
      }

      &.is-promo {
        border: 6px solid var(--primary);
        // border-top: 15px solid var(--primary);
      }

      &.is-active:hover {
        z-index: 1;
      }

      &.is-free {
        width: 25%;
      }

      .plan-description {
        font-size: .9em;
        line-height: 1.25em;
      }

      .button.is-cta {
        height: 3.25em;
        flex-direction: column;
        border-radius: 6px;

        .is-small {
          font-size: .6em;
          margin-top: -.3em;
        }
      }

      .plan-items {
        color: #666;
        text-align: left;
        font-size: 1.1em;
        margin-top: -.25em;
        margin-left: auto;
        margin-right: auto;

        div {
          margin-bottom: .15em;
        }

        .emoji {
          font-size: .85em;
          margin-right: 2px;
          opacity: .8;
        }
      }

      .plan-header {
        color: var(--primary);
        // text-transform: uppercase;
        font-weight: bold;
        font-size: 2.25em;
        padding-top: .15em;
      }

    }
  }

  .plan-items {
    font-size: 1.2em;

    .plan-item {
      text-align: center;
    }
  }

  .plan-description {
    // display: none;
    text-align: center;
  }

  .plan-cta {
    margin: .5em 3em 2em;
  }

  .plan-price {
    // background-color: #e207621f;
    // background-color: #8268a12b;
    color: #222;
    margin: 1em 2.25em;
    border-radius: 6px;
    padding-bottom: 1.25em;

    .plan-price-amount {
      color: black !important;
    }

    .plan-subtitle {
      margin: 0;
    }
  }

  @media screen and (max-width: 768px) {
    .container.is-fluid {
      padding: 0px;
    }

    .pricing-table {
      flex-direction: column;

      .pricing-plan {
        width: 100% !important;

        .plan-header {
          padding-top: 0;
        }
      }
    }
  }
}
</style>
